import { Esrs_DatapointTag_Constraint_, ShortUser } from 'models';
import { Row } from 'read-excel-file';
import { FrequencyEnums, TimePeriodsEnums, QUARTERS_FIELDS } from '../../Requirement';
import { MetricsTableData } from '../MetricAnswers.hooks';
import { excelColumns } from './MetricTableExport.hooks';
import { getTagsCombination } from 'containers/Esrs/utils';

export type ExcelDataType = {
  businessUnit: string;
  disclosureRequirement: string;
  metric: string;
  metricRef: string;
  Q1: number;
  Q2: number;
  Q3: number;
  Q4: number;
  Total: number;
  timePeriod: string;
  tags: string;
}[];

export const matchHeaderToColumnKeys = (fileHeader: Row) => {
  const keys = fileHeader.map(
    (header) =>
      excelColumns.find((col) => col.header.toLowerCase() === String(header).toLowerCase())?.key
  );
  return keys.filter((header) => header !== undefined) as string[];
};

const getTagsFromString = (tags: string) => {
  const regex = /\[(.*?)\^(.*?)\]/g;
  const matches = tags?.length ? [...tags.matchAll(regex)] : [];
  return matches?.map((match) => ({
    tagType: match[1],
    tagValue: match[2],
  }));
};

const getCorrectStringFormat = (number: number | null) => {
  const value = number ? String(number) : null;
  if (value === null) return value;
  if (/^[0-9,.-]*$/.test(value)) return value.replaceAll(',', '');
  if (/^[0-9.-]*$/.test(value)) return value;
  return null;
};

export const getDatapoints = (
  row: ExcelDataType[number],
  user: ShortUser | null,
  metrics: MetricsTableData[],
  companyStandardId: string
) => {
  const isYearly =
    metrics
      .find((m) => m.metric.reference === row.metricRef)
      ?.metric.materialMetrics.find((mm) => mm.materialStandardId === companyStandardId)
      ?.frequency === FrequencyEnums.yearly;
  const tags = getTagsFromString(row.tags);
  if (isYearly) {
    return [
      {
        value: getCorrectStringFormat(row.Total),
        timeframe: TimePeriodsEnums.year,
        tagCombination: getTagsCombination(tags ?? []),
        authorId: user?.id,
        lastEdited: new Date(),
        datapointTags: {
          data: tags ?? [],
          on_conflict: {
            constraint: Esrs_DatapointTag_Constraint_.DatapointTagDatapointIdTagValueTagTypeKey_,
          },
        },
      },
    ];
  } else
    return QUARTERS_FIELDS.map((quarter) => ({
      value: getCorrectStringFormat(row[quarter]),
      timeframe: quarter,
      tagCombination: getTagsCombination(tags ?? []),
      authorId: user?.id,
      lastEdited: new Date(),
      datapointTags: {
        data: tags ?? [],
        on_conflict: {
          constraint: Esrs_DatapointTag_Constraint_.DatapointTagDatapointIdTagValueTagTypeKey_,
        },
      },
    }));
};
